import TableAPI from 'app/components/TableAPI'
import React from 'react'
import { View } from 'styles/reactnative'
import { SllipageColmns } from './columns'

const SlippageUser = ({ }: any) => {
	return (
		<View style={{ width: '100%' }}>
			<TableAPI
				title={'강제 슬리피지 회원'}
				columns={SllipageColmns}
				usermodal={true}
				height={'default'}
				loadingshow={false}
				groupsearch={true}
				width={1350}
				autorefresh={false}
				apikey={'/admin/slip/pslip/user?t='}
			/>
		</View>
	)
}

export default React.memo(SlippageUser)
